import { Component, OnInit, Input } from '@angular/core';

import { Organization } from '@core/objects/organization';
import { UrlService } from '@core/services/url/url.service';

@Component({
    selector: 'organization-profile-logo-img',
    templateUrl: './logo-img.component.html',
    styleUrls: ['./logo-img.component.scss'],
})
export class OrganizationLogoImgComponent implements OnInit {

    @Input() organization: Organization = null;
    @Input() width: number; // height is calculated based on width as width / 2

    public image: string = 'assets/logo_twona.svg';

    constructor(public urlSrv: UrlService) { }

    ngOnInit() {
        if (this.organization != null){
            const timestamp = new Date().getTime(); // Get current timestamp to load a update version of the logo
            this.image = this.urlSrv.buildPublic(`/organizations/${this.organization.uuid}/logo.jpeg?t=${timestamp}`);
        }
    }

}
